import { API_BASE_URL } from '@/constants/api-base'

export const CRM_API_URL = `${API_BASE_URL}/crm`
